const a = (e, r = "en-US") => {
  try {
    const t = new Date(e), o = {
      year: "numeric",
      month: "long",
      day: "numeric"
    }, n = r?.replace("_", "-") || "en-US";
    return t.toLocaleDateString(n, o);
  } catch (t) {
    return console.warn("Error formatting date:", t), e;
  }
};
export {
  a as formatDate
};
//# sourceMappingURL=help-center-knowledge-anatomies9.js.map
